"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M15 .95H1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-12c0-.55-.45-1-1-1zm-9 12H2v-6h4v6zm8 0H7v-6h7v6zm0-7H2v-3h12v3z"];
//# sourceMappingURL=page-layout.js.map